// @flow
import update from 'immutability-helper';
import { Observable, of } from 'rxjs';
import { ofType } from 'redux-observable';
import { catchError, mergeMap, map } from 'rxjs/operators';
import { postContactMessageApi } from './api'

import { setNewAlert } from '../alert/duck';

import type { HTTPError } from '../../error';

export type ContactMessageRequest = {
  email: string;
  subject: string;
  message: string;
};

export type ProductHelperAction = {
  +type: string;
  +error?: HTTPError;
  +contactMessage?: ContactMessageRequest;
};

export type ProductHelperState = {
  +isPostingContactMessage?: boolean;
  +postContactMessageSuccess?: boolean;
  +postContactMessageError?: HTTPError;
};

const PRODUCT_HELPER_POST_CONTACT_MESSAGE_REQUEST = 'PRODUCT_HELPER_POST_CONTACT_MESSAGE_REQUEST';
const PRODUCT_HELPER_POST_CONTACT_MESSAGE_SUCCESS = 'PRODUCT_HELPER_POST_CONTACT_MESSAGE_SUCCESS';
const PRODUCT_HELPER_POST_CONTACT_MESSAGE_ERROR = 'PRODUCT_HELPER_POST_CONTACT_MESSAGE_ERROR';

export function postContactMessage(contactMessage: ContactMessageRequest): ProductHelperAction {
  return {
    type: PRODUCT_HELPER_POST_CONTACT_MESSAGE_REQUEST,
    contactMessage,
  };
}

export function postContactMessageSuccessFn(): ProductHelperAction {
  return {
    type: PRODUCT_HELPER_POST_CONTACT_MESSAGE_SUCCESS,
  };
}

export function postContactMessageErrorFn(error: HTTPError): ProductHelperAction {
  return {
    type: PRODUCT_HELPER_POST_CONTACT_MESSAGE_ERROR,
    error,
  };
}

export const actions = {
  PRODUCT_HELPER_POST_CONTACT_MESSAGE_REQUEST,
  PRODUCT_HELPER_POST_CONTACT_MESSAGE_SUCCESS,
  PRODUCT_HELPER_POST_CONTACT_MESSAGE_ERROR,
  postContactMessage,
  postContactMessageSuccessFn,
  postContactMessageErrorFn,
};

export const initialState: ProductHelperState = {};

export default function reducer(state: ProductHelperState = initialState,
                                action: ProductHelperAction): ProductHelperState {
  switch (action.type) {
    case PRODUCT_HELPER_POST_CONTACT_MESSAGE_REQUEST:
      return update(state, {
        $unset: ['postContactMessageSuccess', 'postContactMessageError'],
        isPostingContactMessage: { $set: true },
      });
    case PRODUCT_HELPER_POST_CONTACT_MESSAGE_SUCCESS:
      return update(state, {
        $unset: ['isPostingContactMessage', 'postContactMessageError'],
        postContactMessageSuccess: { $set: true },
      });
    case PRODUCT_HELPER_POST_CONTACT_MESSAGE_ERROR:
      return update(state, {
        $unset: ['isPostingContactMessage'],
        postContactMessageError: { $set: action.error }
      });
    default:
      return state;
  }
}

export function productHelperPostContactMessageEpic(action$: Observable<ProductHelperAction>): Observable<ProductHelperAction> {
  return action$.pipe(
    ofType(PRODUCT_HELPER_POST_CONTACT_MESSAGE_REQUEST),
    mergeMap(({ contactMessage }) => postContactMessageApi(contactMessage).pipe(
      map(() => postContactMessageSuccessFn()),
      catchError((e: HTTPError) => {
        if (Math.round(e.code / 100) === 5) {
          return of(postContactMessageErrorFn(e),
            setNewAlert('product-helper', 'error', undefined, 'httpErrors.post.500'),
          );
        } else if (e.code === 400) {
          return of(postContactMessageErrorFn(e),
            setNewAlert('product-helper', 'error', undefined, 'httpErrors.post.400'),
          );
        }
        return of(postContactMessageErrorFn(e));
      })))
  );
}



// WEBPACK FOOTER //
// ./src/modules/product-helper/duck.js